export default "__VITE_ASSET__63351b88__"